import Page from '../../classes/Page'
import { app } from '../../utils/store'

export default class SinglePromo extends Page{
    constructor(){
        super({
            id : 'single_promo',
            element: '[data-app-page]',
            // elements: { key : 'nodeElementSelector' }
        })
    }

    create() {
        super.create()
    }
    
    addEventListeners() {
        
    }

    destroy(){ 
        super.destroy()
    }
}